var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarnestroiScBlockchainEtheriumHyperledger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.876,
    height: 61.443,
    viewBox: "0 0 66.876 61.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(1.01 1.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31662",
    "data-name": "Path 31662",
    d: "M25.955,16.067l-6.3-11.211.546-.309,6.3,11.214-.546.307",
    transform: "translate(-6.128 -1.417)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31663",
    "data-name": "Path 31663",
    d: "M27.989,80.561l-.524-.336,7.4-11.612.524.333-7.4,11.614",
    transform: "translate(-8.562 -21.39)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31645",
    "data-name": "Path 31645",
    d: "M51.049,56.034h.008ZM.669,32.6,19.086,58.677l31.757-2.936L64.18,26.721,45.764.643,14.007,3.578ZM18.938,59.317a.311.311,0,0,1-.255-.132L.056,32.811a.323.323,0,0,1-.03-.312L13.518,3.154a.314.314,0,0,1,.255-.18L45.885,0a.3.3,0,0,1,.285.132L64.793,26.509a.305.305,0,0,1,.03.309L51.332,56.166a.308.308,0,0,1-.253.18L18.965,59.317h-.027",
    transform: "translate(0 0)",
    fill: "#012043",
    stroke: "#012043",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31646",
    "data-name": "Path 31646",
    d: "M20.139,4.885l.021,28.893,5.068,26.374L51.457,45l19-16.9L44.79,12.136Zm4.866,55.757L19.848,33.806,19.824,4.469l25.113,7.393,26.041,16.2L51.64,45.251,25.005,60.643",
    transform: "translate(-6.18 -1.393)",
    fill: "#012043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31647",
    "data-name": "Path 31647",
    d: "M57.423,15.213a.934.934,0,1,1-.936-.936.939.939,0,0,1,.936.936",
    transform: "translate(-17.319 -4.451)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31649",
    "data-name": "Path 31649",
    d: "M66.5,63.049a.936.936,0,1,1-.936-.936.937.937,0,0,1,.936.936",
    transform: "translate(-20.146 -19.363)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31651",
    "data-name": "Path 31651",
    d: "M28.357,85.307a.934.934,0,1,1-.936-.936.935.935,0,0,1,.936.936",
    transform: "translate(-8.258 -26.302)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31653",
    "data-name": "Path 31653",
    d: "M20.563,47.083a.936.936,0,1,1-.936-.938.935.935,0,0,1,.936.938",
    transform: "translate(-5.827 -14.385)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31655",
    "data-name": "Path 31655",
    d: "M94.283,38.42a.934.934,0,1,1-.933-.936.935.935,0,0,1,.933.936",
    transform: "translate(-28.809 -11.685)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31657",
    "data-name": "Path 31657",
    d: "M20.563,4.348a.936.936,0,1,1-.936-.938.935.935,0,0,1,.936.938",
    transform: "translate(-5.827 -1.063)",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31659",
    "data-name": "Path 31659",
    d: "M.839,32.569l25.88,14.553L50.749,55.6,51.4,25.792l-5.7-25L20.25,14.771ZM51.053,56.347a.33.33,0,0,1-.1-.016L26.461,47.687.159,32.9A.316.316,0,0,1,.1,32.4L19.89,14.266,45.764.041a.311.311,0,0,1,.454.2l5.8,25.487-.656,30.31a.308.308,0,0,1-.309.3",
    transform: "translate(0 -0.001)",
    fill: "#0e8ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31660",
    "data-name": "Path 31660",
    d: "M20.136,37.476,28.7,40.452l22.8,7.925-2.523-13.3L45.3,15.718ZM51.7,48.612l-.129-.046L19.832,37.535l.1-.091L45.405,15.422,51.7,48.612",
    transform: "translate(-6.183 -4.808)",
    fill: "#012043",
    stroke: "#0e8ece",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31661",
    "data-name": "Path 31661",
    d: "M29.462,21.316l5.03,33.8L60.049,32.253Zm5.85,33L28.995,20.266,61.271,32.453,35.312,54.318",
    transform: "translate(-8.948 -6.341)",
    fill: "#012043",
    stroke: "#012043",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31664",
    "data-name": "Path 31664",
    d: "M87.928,38.592,75.1,37.656l.043-.621,12.827.936-.043.621",
    transform: "translate(-23.412 -11.545)",
    fill: "#012043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31648",
    "data-name": "Path 31648",
    d: "M56.127,14.791l-.062.059a.058.058,0,0,0,.062.059Zm0,2.077A2.018,2.018,0,1,1,58.14,14.85a2.02,2.02,0,0,1-2.012,2.018",
    transform: "translate(-16.956 -5.014)",
    fill: "#012043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31650",
    "data-name": "Path 31650",
    d: "M65.2,62.627l-.062.059a.058.058,0,0,0,.062.059Zm0,2.077a2.018,2.018,0,1,1,2.012-2.018A2.02,2.02,0,0,1,65.2,64.7",
    transform: "translate(-19.5 -18.431)",
    fill: "#012043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31654",
    "data-name": "Path 31654",
    d: "M19.266,46.662l-.059.056a.059.059,0,0,0,.059.059Zm0,2.074a2.017,2.017,0,1,1,2.015-2.018,2.017,2.017,0,0,1-2.015,2.018",
    transform: "translate(-6.619 -13.953)",
    fill: "#012043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31656",
    "data-name": "Path 31656",
    d: "M92.987,38l-.062.056a.06.06,0,0,0,.062.059Zm0,2.074A2.018,2.018,0,1,1,95,38.057a2.02,2.02,0,0,1-2.015,2.018",
    transform: "translate(-29.14 -11.523)",
    fill: "#0e8ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31658",
    "data-name": "Path 31658",
    d: "M19.266,3.928l-.059.059a.061.061,0,0,0,.059.059Zm0,2.074a2.017,2.017,0,1,1,2.015-2.015A2.016,2.016,0,0,1,19.266,6",
    transform: "translate(-5.696 -1.044)",
    fill: "#0e8ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31652",
    "data-name": "Path 31652",
    d: "M27.059,84.885,27,84.944a.059.059,0,0,0,.059.056Zm0,2.074a2.017,2.017,0,1,1,2.018-2.015,2.015,2.015,0,0,1-2.018,2.015",
    transform: "translate(-7.882 -26.52)",
    fill: "#0e8ece"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnestroiScBlockchainEtheriumHyperledger);
export default __webpack_public_path__ + "static/media/earnestroi-sc-blockchain-etherium-hyperledger.8b17f49765711c94192ec3e99b98ca9e.svg";
export { ForwardRef as ReactComponent };